import React, { Ref } from 'react';

import clsx from 'clsx';

import './textbox.css';

type InputMode = 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';

type TextboxCommonProps = {
	'aria-required'?: boolean;
	ariaDescribedBy?: string;
	acceptanceTestTargetId?: string;
	labelledBy?: string;
	invalid?: boolean;
	inputMode?: InputMode;
	ref?: Ref<HTMLInputElement>;
};

export type TextboxProps = React.InputHTMLAttributes<HTMLInputElement> & TextboxCommonProps;

export const Textbox = ({
	ref,
	ariaDescribedBy,
	acceptanceTestTargetId = '',
	'aria-required': ariaRequired,
	className,
	type = 'text',
	invalid,
	labelledBy,
	onKeyDown,
	...rest
}: TextboxProps) => {
	const notAllowedNumerical = ['e', 'E', '+', '-'];

	return (
		<input
			ref={ref}
			className={clsx('form-control', invalid && 'form-control-invalid', className)}
			{...rest}
			aria-describedby={ariaDescribedBy}
			aria-labelledby={labelledBy}
			aria-required={ariaRequired}
			data-field-invalid={invalid ? true : null}
			data-pp-at-target={acceptanceTestTargetId}
			spellCheck={false}
			type={type}
			onKeyDown={e => {
				if (type === 'number' && notAllowedNumerical.includes(e.key)) {
					e.preventDefault();
				}

				if (onKeyDown) onKeyDown(e);
			}}
			onWheel={e => type === 'number' && e.currentTarget.blur()}
		/>
	);
};
